// URL de base du client
export var PUBLIC_URL = process.env.PUBLIC_URL || "/";
// Titre du site
export var SITE_TITLE = process.env.REACT_APP_SITE_TITLE || "ETCRM";
// URL ETCRM
export var ETCRM_URL = process.env.REACT_APP_ETCRM_URL;
export var ETCRM_API_URL = "".concat(ETCRM_URL, "/themes/etcrm2/api");
export var ETCRM_LEGACY_URL = "".concat(ETCRM_URL, "/index.php");
export var ETCRM_V8_API_URL = "".concat(ETCRM_URL, "/V8");
export var TOKEN_ENDPOINT = "".concat(ETCRM_API_URL, "/access_token");
// URL des traductions
export var TRANSLATION_URL = process.env.REACT_APP_TRANSLATION_URL || "".concat(ETCRM_API_URL, "/translations");
// Log
export var LOG_LOGGER_NAME = process.env.REACT_APP_LOG_LOGGER_NAME || "ETCRM";
export var LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || "ERROR";
// Debug show revision
export var APP_REVISION_NO = process.env.REACT_APP_REVISION;
// API Client config
export var CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export var CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export var VITE_CLAUDE_API_KEY = process.env.VITE_CLAUDE_API_KEY;
